document.addEventListener('DOMContentLoaded', function() {
  // Find the Mahogany variant label
  const mahoganyInputs = document.querySelectorAll('fieldset.js.product-form__input input[type="radio"]');
  
  mahoganyInputs.forEach(function(input) {
    if (input.value && input.value.includes('Mahogany')) {
      const label = input.nextElementSibling;
      
      // Create the recommended badge
      const badge = document.createElement('span');
      badge.className = 'recommended-badge';
      badge.innerHTML = '✨ Recommended';
      
      // Insert badge into the label
      label.style.position = 'relative';
      label.insertBefore(badge, label.firstChild);
    }
  });
  
  // Update badge color when ANY variant is selected/deselected
  const allRadios = document.querySelectorAll('fieldset.js.product-form__input input[type="radio"]');
  allRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      const allBadges = document.querySelectorAll('.recommended-badge');
      allBadges.forEach(function(badge) {
        const parentLabel = badge.parentElement;
        const parentInput = parentLabel.previousElementSibling;
        
        if (parentInput && parentInput.checked) {
          badge.classList.add('selected');
        } else {
          badge.classList.remove('selected');
        }
      });
    });
  });
});
